import { render, staticRenderFns } from "./ShopMarkers.vue?vue&type=template&id=3080d076"
import script from "./ShopMarkers.vue?vue&type=script&lang=js"
export * from "./ShopMarkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports